import { BP42InitialState } from '@r1-frontend/bp42/reducer/initialState';

const getInitialValue = (state: BP42InitialState) => ({
    name: state.formData.name.value,
    phone: state.formData.phone.value,
});

export default getInitialValue;
